module.exports = __webpack_public_path__ + "static/img/VIP.def2f6e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/VIP.png
// module id = r1E7
// module chunks = 4